/// <amd-module name="Test/common-util/TestOutcomeUtils" />
import { TestOutcome } from "Test/common-util/Contracts/Test";
import * as Resources from "Test/common-util/Resources";
import { IconDetails } from "Test/common-util/Common.Utils";
import { TestOutcomeEnum } from "Test/common-util/Common";

export function getIconDetails(outcome: TestOutcome | TestOutcomeEnum) {
    return (outcome) ? _testOutcomeToIconDetailsMapping[outcome] : _testOutcomeToIconDetailsMapping[TestOutcome.None];
}

export function getFriendlyName(outcome: TestOutcome | TestOutcomeEnum) {
    return _testOutcomeToFriendlyNameMapping[outcome];
}

const _testOutcomeToFriendlyNameMapping: { [key: string]: string } = {
    [TestOutcome.Unspecified] : Resources.TestOutcome_Result_Unspecified,
    [TestOutcome.None] : Resources.TestOutcome_None,
    [TestOutcome.Passed] : Resources.TestOutcome_Passed,
    [TestOutcome.Failed] : Resources.TestOutcome_Failed,
    [TestOutcome.Inconclusive] : Resources.TestOutcome_Inconclusive,
    [TestOutcome.Timeout] : Resources.TestOutcome_Timeout,
    [TestOutcome.Aborted] : Resources.TestOutcome_Aborted,
    [TestOutcome.Blocked] : Resources.TestOutcome_Blocked,
    [TestOutcome.NotExecuted] : Resources.TestOutcome_NotExecuted,
    [TestOutcome.Warning] : Resources.TestOutcome_Warning,
    [TestOutcome.Error] : Resources.TestOutcome_Error,
    [TestOutcome.NotApplicable] : Resources.TestOutcome_NotApplicable,
    [TestOutcome.Paused] : Resources.TestOutcome_Paused,
    [TestOutcome.InProgress] : Resources.TestOutcome_InProgress,
    [TestOutcome.NotImpacted] : Resources.TestOutcome_NotImpacted,
    [TestOutcomeEnum.Others] : Resources.TestOutcome_Others
};

const _testOutcomeToIconDetailsMapping: { [key: string]: IconDetails } = {
    [TestOutcome.Unspecified] : { iconName: "Help", className: "icon-inconclusive" },
    [TestOutcome.None] : { iconName: "Remove", className: "icon-inconclusive" },
    [TestOutcome.Passed] : { iconName: "CheckMark", className: "icon-passed" },
    [TestOutcome.Failed] : { iconName: "Cancel", className: "icon-failed" },
    [TestOutcome.Inconclusive] : { iconName: "Unknown", className: "icon-inconclusive" },
    [TestOutcome.Timeout] : { iconName: "Clock", className: "icon-inconclusive" },
    [TestOutcome.Aborted] : { iconName: "CircleStop", className: "icon-failed" },
    [TestOutcome.Blocked] : { iconName: "Blocked2", className: "icon-failed" },
    [TestOutcome.NotExecuted] : { iconName: "NotExecuted", className: "icon-inconclusive" },
    [TestOutcome.Warning] : { iconName: "Warning", className: "icon-warning" },
    [TestOutcome.Error] : { iconName: "Error", className: "icon-failed" },
    [TestOutcome.NotApplicable] : { iconName: "Blocked", className: "icon-inconclusive" },
    [TestOutcome.Paused] : { iconName: "CirclePause", className: "icon-inconclusive" },
    [TestOutcome.InProgress] : { iconName: "MSNVideos", className: "icon-inprogress" },
    [TestOutcome.NotImpacted] : { iconName: "NotImpactedSolid", className: "icon-inconclusive" },
    [TestOutcomeEnum.Others] : { iconName: "Unknown", className: "icon-inconclusive" }
}
